module.exports = __webpack_public_path__ + "static/polityka-61cb6e659ddabd41db67bf1710079f15.pdf";